import React, { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";

function ErrorPage({ status, statusText }: { status: any; statusText: any }) {
  const location = useLocation();
  const statusCode = status?.toString() || "";
  const title = statusText || "An unexpected error occurred";

  useEffect(() => {
    if (statusCode === "401") {
      window.sessionStorage.setItem("redirectUrl", location.pathname + location.searchStr);
      window.location.href = "/auth/signIn";
    }
  }, [statusCode, location.pathname]);

  // Don't render anything for 401 — just redirect silently
  if (statusCode === "401") {
    return null;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-blue-500">
      <div className="text-center px-6">
        <h1 className="text-8xl font-bold text-white tracking-tight">
          {statusCode || "Error"}
        </h1>
        <p className="mt-4 text-xl text-blue-50">{title}</p>
        <a
          href="/"
          className="mt-8 inline-block rounded-md bg-white px-6 py-3 text-sm font-medium text-blue-500 hover:bg-blue-50 transition-colors"
        >
          Return to Home
        </a>
      </div>
    </div>
  );
}

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: any }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: any) {
    return { error };
  }

  render() {
    const status = this.state.error?.status;
    const statusText = this.state.error?.statusText;

    if (this.state.error) {
      return <ErrorPage status={status} statusText={statusText} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
